import { useCallback } from 'react';

export function useMouseLeaveHandle(onHover?: (value: boolean) => void) {
  return useCallback(() => onHover && onHover(false), []);
}
